import React from "react";

export default function EyeIcon({ open }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      className="block"
      xmlns="http://www.w3.org/2000/svg"
    >
      {open ? (
        <>
          <path
            d="M2 12C3.8 7.5 7.6 5 12 5C16.4 5 20.2 7.5 22 12C20.2 16.5 16.4 19 12 19C7.6 19 3.8 16.5 2 12Z"
            stroke="#2B7F8D"
            strokeWidth="1.8"
          />
          <circle cx="12" cy="12" r="3" stroke="#2B7F8D" strokeWidth="1.8" />
        </>
      ) : (
        <>
          <path
            d="M2 12C3.8 7.5 7.6 5 12 5C16.4 5 20.2 7.5 22 12C20.2 16.5 16.4 19 12 19C7.6 19 3.8 16.5 2 12Z"
            stroke="#2B7F8D"
            strokeWidth="1.8"
          />
          <path
            d="M4 4L20 20"
            stroke="#2B7F8D"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M9.5 9.5C10.1 8.9 11 8.5 12 8.5C13.9 8.5 15.5 10.1 15.5 12C15.5 13 15.1 13.9 14.5 14.5"
            stroke="#2B7F8D"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  );
}
